export const Bio = {
  name: "Yash Kumar",
  roles: ["Frontend Developer", "WordPress Developer", "Programmer"],
  description:
    "I am a motivated and versatile developer with a passion for building user-centric web solutions. Skilled in frontend and backend technologies, I specialize in creating responsive, SEO-optimized platforms with modern frameworks like React, Next.js, and WordPress. My expertise extends to AI and machine learning, with a focus on delivering innovative and scalable solutions.",
  github: "https://github.com/yashkumar4443",
  resume:
    "https://drive.google.com/file/d/18iu5hQyx7CySIfRBbMYbUgXmhPM0QEQr/view?usp=sharing",
  linkedin: "https://www.linkedin.com/in/yash-kumar-77b090140/",
  phone: "+91-9627204461",
  email: "yashkumar44431@gmail.com",
  portfolio: "http://yashportfolio.com/",
};

export const skills = [
  {
    title: "Frontend Technologies",
    skills: [
      {
        name: "HTML5",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },
      {
        name: "CSS3",
        image:
          "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/css3/css3-original.svg",
      },
      {
        name: "JavaScript (ES6+)",
        image:
          "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/javascript/javascript-original.svg",
      },
      {
        name: "TypeScript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/4/4c/Typescript_logo_2020.svg",
      },
      {
        name: "React.js",
        image:
          "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg",
      },
      {
        name: "Next.js",
        image:
          "https://img.icons8.com/?size=512&id=yUdJlcKanVbh&format=png",
      },
      {
        name: "Redux",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/redux/redux-original.svg",
      },
      {
        name: "Tailwind CSS",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/6/6e/Hasyim50px-TailwindCSS_Logo.png",
      },
      {
        name: "WordPress",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/9/98/WordPress_blue_logo.svg",
      },
      {
        name: "Elementor",
        image:
          "https://cdn.wpml.org/wp-content/uploads/2017/09/Elementor-Logo-Symbol-Red.png",
      },
    ],
  },
  {
    title: "Backend & APIs",
    skills: [
      {
        name: "Node.js",
        image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nodejs/nodejs-original.svg",
      },
      {
        name: "Express.js",
        image:
          "https://images.codingblocks.com/web/express.png",
      },
      {
        name: "PHP",
        image: "https://www.php.net/images/logos/new-php-logo.svg",
      },
      {
        name: "MongoDB",
        image:
          "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mongodb/mongodb-original.svg",
      },
      {
        name: "MySQL",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original.svg",
      },
      {
        name: "REST APIs",
        image: "https://dfdmyvckxgqn5.cloudfront.net/_app/immutable/assets/building-elegant-rest-apis.c9888e28.webp",
      },
    ],
  },
  {
    title: "DevOps & Hosting",
    skills: [
      {
        name: "Docker",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/docker/docker-original.svg",
      },
      {
        name: "AWS (EC2, S3)",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/9/93/Amazon_Web_Services_Logo.svg",
      },
      {
        name: "DigitalOcean",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/f/ff/DigitalOcean_logo.svg",
      },
      {
        name: "CI/CD (GitHub Actions)",
        image: "https://upload.wikimedia.org/wikipedia/commons/9/91/Octicons-mark-github.svg",
      },
      {
        name: "Nginx",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/c/c5/Nginx_logo.svg",
      },
    ],
  },
  {
  title: "SEO & Analytics",
  skills: [
    {
      name: "Technical SEO",
      image: "https://cdn.simpleicons.org/google"
    },
    {
      name: "Google Analytics",
      image: "https://cdn.simpleicons.org/googleanalytics"
    },
    {
      name: "SEMrush",
      image: "https://cdn.simpleicons.org/semrush"
    },
    {
      name: "Ahrefs",
      image: "https://ahrefs.com/assets/esbuild/primary-blue-BJ5CMGSK.png"
    },
    {
      name: "Microsoft Clarity",
      image: "https://clarity.microsoft.com/blog/wp-content/uploads/2025/02/siteIcon.png"
    },
    {
      name: "Structured Data",
      image: "https://cdn.simpleicons.org/json"
    },
    {
      name: "Facebook Pixel",
      image: "https://cdn.simpleicons.org/facebook"
    },
    {
      name: "HubSpot",
      image: "https://cdn.simpleicons.org/hubspot"
    },
    {
      name: "Pardot",
      image: "https://cdn.simpleicons.org/salesforce/00A1E0"
    }
  ]
},
  {
    title: "Tools & Platforms",
    skills: [
      {
        name: "Git",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/git/git-original.svg",
      },
      {
        name: "Figma",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/figma/figma-original.svg",
      },
      {
        name: "Postman",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/postman/postman-original.svg",
      },
      {
        name: "NextAuth.js",
        image: "https://next-auth.js.org/img/logo/logo-sm.png",
      },
      {
        name: "WooCommerce",
        image:
          "https://play-lh.googleusercontent.com/aPsA6vS25mrocOJqZhTZyxm7sntS_IZuHh4oLBI6v-70A_mLV0Fe0spqSDTbK_Fy8As=w480-h960-rw",
      },
      {
        name: "VS Code",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/vscode/vscode-original.svg",
      },
    ],
  },
  {
    title: "Foundations",
    skills: [
      { name: "Data Structures & Algorithms" },
      { name: "MVC Architecture" },
      { name: "Server-Side Rendering (SSR)" },
      { name: "Static Site Generation (SSG)" },
      { name: "Responsive Design" },
    ],
  },
];

export const experiences = [
  {
    id: 0,
    img: "https://aashaykumar.in/wp-content/uploads/2026/04/Statusneo-img.png",
    role: "Senior Consultant",
    company: "Statusneo Technology Consulting Pvt Ltd",
    link: "https://statusneo.com",
    doc: "https://aashaykumar.in/wp-content/uploads/2026/04/cwv-paragonhealthcare.png",
    date: "July 2025 – Present",
    location: "Gurugram",
    desc: "Managing and scaling the WordPress platform for Paragon Healthcare (Carelon / Elevance Health), supporting 35,000+ patients across 40+ U.S. locations. Leading performance optimization, SEO, and large-scale content operations on WP Engine. Improved Core Web Vitals, ensured high availability, and delivered continuous enhancements for a secure, high-traffic healthcare platform. Remediated 15,000+ accessibility issues in line with WCAG standards, enhancing compliance and user experience across the platform.",
    skills: [
      "Wordpress",
      "WP-Engine",
      "Oxygen Builder",
      "Node.js",
      "Azure",
      "Google Analytics",
      "Docker",
      "SEO",
    ],
  },
  {
    id: 1,
    img: "https://aashaykumar.in/wp-content/uploads/2025/05/SE_logo.png",
    role: "WordPress Developer",
    company: "Sustainability Economics",
    link: "https://sustainabilityeconomics.ai",
    date: "June 2024 – June 2025",
    location: "Bangalore, KA",
    desc: "Developed NextGen AI News using Wordpress and Next.js, achieving 95+ Lighthouse scores through SSR, ISR, SEO, and RSS integration. Migrated Sustainability Economics News from WordPress to Next.js, improving SEO by 80% and reducing load time by 90%. Built responsive dashboards and REST APIs with React, Node.js, and MongoDB, cutting UI delivery time by 50%. Integrated Google Analytics and Microsoft Clarity for user behavior tracking. Implemented OAuth2 with NextAuth.js for 10K+ users and streamlined AWS EC2 deployment with Docker.",
    skills: [
      "Next.js",
      "React.js",
      "Node.js",
      "MongoDB",
      "Google Analytics",
      "Microsoft Clarity",
      "NextAuth.js",
      "AWS EC2",
      "Docker",
      "SEO",
      "SSR",
      "ISR",
    ],
  },
  // {
  //   id: 1,
  //   img: "https://www.phemesoft.com/companywebsite/wp-content/uploads/2022/09/cropped-autoenhance_enrich_Pheme_Logo_edited-300x84.png",
  //   role: "Machine Learning Project Intern",
  //   company: "Pheme Software Pvt Ltd",
  //   date: "Jan 2024 – May 2024",
  //   location: "Remote",
  //   desc: "Led development of an AI-based voice assistant, focusing on natural language processing, speech recognition, and voice user interface (VUI) design. Utilized TensorFlow and PyTorch for deep learning models, enhancing text-to-speech (TTS) and automatic speech recognition (ASR) functionalities.",
  //   skills: [
  //     "Machine Learning",
  //     "Deep Learning",
  //     "Natural Language Processing (NLP)",
  //     "Python",
  //     "TensorFlow",
  //     "PyTorch",
  //     "Text-to-Speech (TTS)",
  //     "Automatic Speech Recognition (ASR)",
  //   ],
  // },
  {
    id: 2,
    img: "https://www.bugendaitech.com/design/images/logo.png",
    role: "Associate PHP/WordPress Developer",
    company: "BugendaiTech Pvt. Ltd.",
    link: "https://bugendaitech.com",
    date: "Oct 2020 – Dec 2023",
    location: "Remote",
    desc: "Managed CRM, CMS, and integrations with Pardot, Marketing Cloud, and Hubspot for marketing automation. Developed custom WordPress themes, plugins, and WooCommerce projects with payment and end-to-end SEO integrations.",
    skills: [
      "WordPress",
      "PHP",
      "Pardot",
      "Salesforce Marketing Cloud",
      "Hubspot",
      "WooCommerce",
      "SEO",
      "JavaScript",
      "Bootstrap",
      "Tailwind CSS",
      "MySQL",
    ],
  },
  {
    id: 3,
    img: "https://www.bugendaitech.com/design/images/logo.png",
    role: "WordPress Developer - Intern",
    company: "BugendaiTech Pvt. Ltd.",
    link: "https://bugendaitech.com",
    date: "June 2020 – Sep 2020",
    location: "Remote",
    desc: "Designed WordPress landing pages and set up analytics with Google Analytics and Hubspot.",
    skills: ["WordPress", "Google Analytics", "Hubspot"],
  },
];

export const education = [
  {
    id: 0,
    img: "https://aashaykumar.in/wp-content/uploads/2024/01/upes.png",
    school: "University of Petroleum & Energy Studies, Dehradun",
    date: "2022 – 2024",
    desc: "Pursued a Master's degree in Computer Applications specializing in Artificial Intelligence and Machine Learning. Studied Data Structures, Algorithms, Object-Oriented Programming, Database Management Systems, Operating Systems, and Computer Networks.",
    degree:
      "Master of Computer Applications - MCA (Artificial Intelligence and Machine Learning)",
  },
  {
    id: 1,
    img: "https://aashaykumar.in/wp-content/uploads/2024/01/upes.png",
    school: "University of Petroleum & Energy Studies, Dehradun",
    date: "2017 – 2020",
    desc: "Completed a Bachelor's degree in Computer Applications with a CGPA of 6.2. Studied Data Structures, Algorithms, Object-Oriented Programming, Database Management Systems, Operating Systems, and Computer Networks.",
    degree: "Bachelor of Computer Applications - BCA",
  },
  {
    id: 2,
    img: "https://aashaykumar.in/wp-content/uploads/2024/01/12class.png",
    school: "MS Memorial Public School, Motihari",
    date: "2017",
    desc: "Completed Class 12 with a focus on Science and Computer Science under the CBSE curriculum.",
    degree: "CBSE (XII), PCM",
  },
  {
    id: 3,
    img: "https://aashaykumar.in/wp-content/uploads/2024/01/10class.png",
    school: "RBN Global School, Lucknow",
    date: "2015",
    desc: "Completed Class 10 under the CBSE curriculum.",
    degree: "CBSE (X)",
  },
];

export const projects = [
  {
    id: 0,
    title: "Paragonhealthcare",
    description:
      "Managed and scaled the enterprise WordPress platform for Paragon Healthcare (Carelon / Elevance Health), serving 35,000+ patients across 40+ U.S. locations. Led performance optimization achieving Core Web Vitals 'Passed' status (LCP: 1.2s, INP: 28ms, CLS: 0.06). Improved SEO, platform stability, and accessibility by remediating 15,000+ WCAG issues. Ensured high availability and continuous enhancements on WP Engine for a secure, high-traffic healthcare system.",
    image:
      "https://aashaykumar.in/wp-content/uploads/2026/04/paragonhealthcare.jpeg",
    tags: ["WordPress", "PHP", "SEO", "Oxygen Builder", "WP Engine"],
    category: "web app",
    webapp: "https://paragonhealthcare.com",
  },
  {
    id: 1,
    title: "RemOrganics",
    description: "Built and managed the Shopify e-commerce store for Rem Organics Pvt. Ltd. — an Indian manufacturer and exporter of organic Makhana's — handling theme customization, product catalog setup, and store management",
    image:
      "https://aashaykumar.in/wp-content/uploads/2026/04/remorganics-scaled.png",
    tags: ["Shoppify", "PHP", "SEO"],
    category: "web app",
    webapp: "https://remorganics.com/",
  },
  {
    id: 1,
    title: "MyCleanHome",
    description:
      "Built a WordPress-based website for professional home cleaning services with a focus on SEO (81/100 score) and user engagement. Implemented an instant quote system and streamlined booking process, optimizing meta tags and structured data for better visibility.",
    image:
      "https://aashaykumar.in/wp-content/uploads/2025/05/mycleanhome-ss.png",
    tags: ["WordPress", "PHP", "SEO", "Structured Data"],
    category: "web app",
    webapp: "https://mycleanhome.com",
  },
  {
    id: 2,
    title: "Tea Time Stories E-Commerce Website",
    description:
      "Developed a full e-commerce platform using custom WordPress and WooCommerce, integrating secure end-to-end payment gateways and responsive design for seamless user experience.",
    image:
      "https://aashaykumar.in/wp-content/uploads/2025/05/Teatimestoriesbygitanjali-ss.png",
    tags: ["WordPress", "WooCommerce", "PHP", "Payment Gateways"],
    category: "web app",
    webapp: "https://teatimestoriesbygitaanjali.com/",
  },
  {
    id: 3,
    title: "2022 Family Planning Review Website",
    description:
      "Developed a custom responsive WordPress platform for PRB’s 2022 Family Planning Review, covering trends in 22 Sub-Saharan African countries. Integrated Highcharts, Google Charts, and multilingual support (English/French) for enhanced engagement. Configured Google Analytics and REST APIs for real-time data tracking.",
    image:
      "https://2022-family-planning-review.prb.org/wp-content/uploads/2022/05/cropped-Favicon-512.png",
    tags: [
      "WordPress",
      "PHP",
      "Highcharts",
      "Google Charts",
      "REST APIs",
      "Google Analytics",
    ],
    category: "web app",
    webapp: "https://2022-family-planning-review.prb.org/",
  },
  {
    id: 5,
    title: "Shopplyft",
    description:
      "Created a WordPress-based e-commerce platform for Shopplyft, focusing on responsive design and SEO optimizations. Integrated WooCommerce for seamless product management and payment gateways, enhancing user experience and conversion rates.",
    image:
      "https://aashaykumar.in/wp-content/uploads/2025/05/Shopplyft-ss.png",
    tags: ["WordPress", "WooCommerce", "PHP", "SEO", "Payment Gateways"],
    category: "web app",
    webapp: "https://shopplyft.com/",
  },
  {
    id: 6,
    title: "Renascence Center",
    description:
      "Built a WordPress website for Renascence CENTER, a wellness and therapy service provider, with a focus on user-friendly design and SEO. Implemented custom forms and booking integrations to streamline client interactions and improve online visibility.",
    image:
      "https://aashaykumar.in/wp-content/uploads/2025/05/renascencecenter-ss.png",
    tags: ["WordPress", "PHP", "SEO", "Custom Forms"],
    category: "web app",
    webapp: "https://www.renascencecenter.com/",
  },
  {
    id: 7,
    title: "Aitobi",
    description:
      "Designed a WordPress-based website for Aitobi, focusing on clean design and SEO optimizations. Integrated custom plugins for enhanced functionality and user engagement, ensuring a seamless experience across devices.",
    image: "https://aashaykumar.in/wp-content/uploads/2025/05/aitobi-ss.png",
    tags: ["WordPress", "PHP", "SEO", "Custom Plugins"],
    category: "web app",
    webapp: "https://aitobi.co/",
  },
  {
    id: 8,
    title: "BugendaiTech",
    description:
      "Contributed to the development of BugendaiTech’s custom WordPress website, integrating bespoke themes and plugins for enhanced functionality. Focused on SEO, responsive design, and analytics integrations to showcase the company’s tech services.",
    image: "https://aashaykumar.in/wp-content/uploads/2025/05/bgtech-ss.png",
    tags: [
      "WordPress",
      "PHP",
      "SEO",
      "Custom Themes",
      "Custom Plugins",
      "Google Analytics",
    ],
    category: "web app",
    webapp: "https://bugendaitech.com/",
  },
  {
    id: 9,
    title: "Aashay Kumar",
    description:
      "Built a custom WordPress portfolio website to showcase my skills, projects, and experiences. Implemented SEO optimizations, responsive design, and custom integrations to create a professional and engaging online presence.",
    image:
      "https://aashaykumar.in/wp-content/uploads/2025/05/aashay-ss.png",
    tags: ["WordPress", "PHP", "SEO", "Custom Themes", "Responsive Design"],
    category: "web app",
    webapp: "https://aashaykumar.in/",
  },
];

export const certifications = [
  { name: "Angular (Basic)", issuer: "HackerRank" },
  { name: "React (Basic)", issuer: "HackerRank" },
  { name: "Google Analytics for Beginners", issuer: "Google" },
  { name: "SEMrush SEO Toolkit", issuer: "SEMrush" },
  { name: "Inbound Marketing", issuer: "Hubspot" },
];
